<app-spinner></app-spinner>


<div class="overflow-hidden">
    <div class="sigma_subheader style-6 bg-cover bg-center title-banner">
        <div class="container">
            <div class="sigma_subheader-inner">
                <br>
                <br>
                <h1>SURVEY FORM</h1>
            </div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a class="btn-link" routerLink="/">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                    Survey Form - Delivery
                </li>
            </ol>
        </div>
    </div>

    <div class="container">
        <div class="row" *ngIf="result?.deliveries[0]?.completedNoOfBoxes  && !feedbackExists">

            <h2><!-- Delivery Feedback --></h2>
            <p><b>Invoice # {{refno}}</b><!--  | Delivered on Oct 24 --></p>
            <p><b>Sender:</b> <span style="text-transform: capitalize;"> {{result?.invoice?.customerFullname}}</span></p>
            <p><b>Consignee:</b> <span style="text-transform: capitalize;"> {{result?.invoice?.consigneeName}}</span></p>
            <p><b>No. of Boxes: </b>{{result?.invoice?.noOfBoxes}} {{ result?.invoice?.boxes }}</p>
            <p><b>Delivery Driver: </b><span style="text-transform: capitalize;">
                    {{result?.deliveries[0]?.driverName}}</span></p>
            <br>
            <hr>

            <form [formGroup]="form" (ngSubmit)="submit()">

                <!-- Rating -->
                <div class="form-group">
                    <h4>1. How was your delivery experience?</h4>
                    <div class="rating">
                        <button type="button" *ngFor="let r of [1,2,3,4,5,6,7,8,9]" (click)="selectRating(r)"
                            [class.selected]="form.value.rating === r">
                            {{r}}
                        </button>
                    </div>
                    <div class="error-message" *ngIf="
                            formControl.rating.invalid &&
                            (formControl.rating.dirty ||
                            formControl.rating.touched ||
                            isSubmitted)
                        ">
                        <span class="text-danger" *ngIf="formControl.rating.errors?.required">
                            Rating is required.
                        </span>

                        <span class="text-danger"
                            *ngIf="formControl.rating.errors?.min || formControl.rating.errors?.max">
                            Rating must be between 1 and 9.
                        </span>
                    </div>
                </div>

                <hr>

                <!-- Options -->
                <div class="form-group">
                    <h4>2. What stood out to you?</h4>
                    <div *ngFor="let option of options; let i = index">
                        <input class="form-check-input" type="checkbox" [id]="'opt' + i"
                            (change)="toggleOption(option.id, $event)">

                        <label class="form-check-label" [for]="'opt' + i">
                            {{ option.optionName }}
                        </label>
                    </div>
                    <div class="error-message" *ngIf="
                            selectedOptions.invalid &&
                            (selectedOptions.dirty ||
                            selectedOptions.touched ||
                            isSubmitted)
                        ">
                        <span class="text-danger" *ngIf="selectedOptions.errors?.required">
                            Please select at least one option.
                        </span>
                    </div>
                </div>

                <hr>

                <!-- Comments -->
                <div class="form-group">
                    <h4>3. Any additional comments? (OPTIONAL)</h4>
                    <textarea formControlName="additionalComments"></textarea>
                </div>

                <br>

                <div class="col-12">
                    <div class="d-grid gap-2">
                        <button type="submit" class="btn btn-axp-theme">Submit Feedback</button>
                    </div>
                </div>
                <!-- <button type="submit">Submit Feedback</button> -->

            </form>

            <div class="col-lg-8" hidden>
                <div class="sigma_post-details-inner">
                    <div class="entry-content">
                        <div class="sigma_post-details-categories">
                            <a routerLink="/balikbayan-box" class="sigma_post-category">Balikbayan Boxes</a>
                        </div>
                        <p class="entry-title">
                            Welcome to LOGO, your premier Door-to-Door Balikbayan Cargo Delivery service!
                            Through advanced automated logistics systems you can rest assured, your
                            Balikbayan Boxes will be safely and securely delivered from our numerous
                            branches across the U.S., Canada and Europe to any destination in the
                            Philippines.
                        </p>
                    </div>

                    <!-- Recent services Widget -->
                    <div class="widget widget-sigma-recent-posts mb-3" hidden>
                        <div class="sigma_recent-post">
                            <a class="recent-post-image">
                                <i class="flaticon-logistics" style="font-size: 64px"></i>
                            </a>
                            <div class="recent-post-descr">
                                <h5>OCEAN FREIGHT</h5>
                                <p>
                                    LOGO ensures that all your Balikbayan box shipments are handled efficiently
                                    and will arrive at their destination completely intact.
                                </p>
                            </div>
                        </div>
                        <div class="sigma_recent-post">
                            <a class="recent-post-image">
                                <i class="flaticon-export" style="font-size: 64px"></i>
                            </a>
                            <div class="recent-post-descr">
                                <h5>CONTAINER SHIPMENT</h5>
                                <p>
                                    LOGO offers competitive rates for large-scale volume shipments for
                                    our balikbayan fellows and their belongings.
                                </p>
                            </div>
                        </div>
                        <div class="sigma_recent-post">
                            <a class="recent-post-image">
                                <i class="flaticon-cargo" style="font-size: 64px"></i>
                            </a>
                            <div class="recent-post-descr">
                                <h5>LOOSE CARGO SHIPMENT</h5>
                                <p>
                                    LOGO provides shipments for non-packaged cargo for your special
                                    padala and packages.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center" *ngIf="result?.deliveries[0]?.type === 'DeliveryPoint' &&
                          !result?.deliveries[0]?.completedNoOfBoxes && !feedbackExists">
            <div class="col-md-10 col-lg-8">
                <div class="card border-0 shadow-sm">
                    <div class="card-body p-4">
                        <div class="d-flex align-items-start">
                            <div class="flex-shrink-0 me-3">
                                <div class="d-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10"
                                    style="width: 60px; height: 60px; padding: 10px">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                        <path
                                            d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
                                    </svg>
                                </div>
                            </div>

                            <div class="flex-grow-1">
                                <h5 class="card-title text-dark mb-2">
                                    <strong>Package Items has not been delivered.</strong>
                                </h5>
                                <p class="card-text text-muted mb-3">
                                    We couldn't locate an invoice with the number you provided.
                                    This might happen if:
                                </p>
                                <ul class="list-unstyled text-muted mb-3">
                                    <li class="mb-1">
                                        • The invoice number was entered incorrectly
                                    </li>
                                    <li class="mb-1">
                                        • The invoice is from a different account
                                    </li>
                                    <li>• There may be a system delay in processing</li>
                                </ul>

                                <div class="d-flex flex-wrap gap-2 align-items-center">
                                    <!-- <button class="btn btn-outline-primary btn-sm">
                    <i class="fas fa-redo me-1"></i>
                    Try Again
                  </button> 

                  <span class="text-muted small">or</span>-->

                                    <a href="tel:{{ telephone }}" class="btn btn-link btn-sm text-decoration-none p-0">
                                        <i class="fas fa-phone me-1"></i>
                                        Call Support: {{ telephone }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center" *ngIf="result?.deliveries[0]?.completedNoOfBoxes && feedbackExists">
            <div class="col-md-10 col-lg-8">
                <div class="card border-0 shadow-sm">
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center">

                            <!-- Icon -->
                            <div class="flex-shrink-0 me-3">
                                <div class="d-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10"
                                    style="width: 60px; height: 60px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="white"
                                        class="bi bi-hand-thumbs-up" viewBox="0 0 16 16">
                                        <path
                                            d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                                    </svg>
                                </div>
                            </div>
                            <!-- Message -->
                            <div>
                                <h5 class="mb-1 fw-bold text-success">
                                    Feedback Already Submitted
                                </h5>

                                <p class="mb-0 text-muted">
                                    Thank you! Your feedback for this transaction has already been recorded.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>